import { defaultSchema } from "rehype-sanitize";

export const HELP_TOPIC_MARKDOWN_SANITIZE_SCHEMA = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    img: [...(defaultSchema.attributes?.img ?? []), "className", "loading"],
  },
};
